export enum BankAccountScheme {
    ACH = 'ach',
    IBAN = 'iban',
    BACS = 'bacs',
    BECS = 'becs',
    SWIFT = 'swift',
    CNAPS = 'cnaps',
    ACSS = 'acss',
    SPEI = 'spei',
    FPS = 'fps',
    SWIFTWithIban = 'swift-iban',
    Intradagclearing = 'intradagclearing',
    MEPS = 'meps',
    SGDSwift = 'sgd-swift',
    FEDWIRE = 'fedwire',
    RTGS = 'rtgs',
}
